import React from 'react';
import { Check, ChevronsUpDown } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '../../ui/popover';
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from '../../ui/command';
import { adminApi } from '../../../lib/adminAuth';

let cache = null;
export function useClients() {
  const [clients, setClients] = React.useState(cache || []);
  React.useEffect(() => {
    if (cache) return;
    adminApi.get('/api/admin/clients').then((r) => {
      const list = Array.isArray(r.data) ? r.data : r.data?.clients || [];
      cache = list.filter((c) => !c.is_archived).sort((a, b) => (a.name || '').localeCompare(b.name || ''));
      setClients(cache);
    }).catch(() => {});
  }, []);
  return clients;
}

export default function ClientPicker({ value, onChange, testId = 'client-picker' }) {
  const clients = useClients();
  const [open, setOpen] = React.useState(false);
  const current = clients.find((c) => c._id === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" className="w-full h-10 px-3 rounded-lg border border-slate-200 bg-white text-sm flex items-center justify-between" data-testid={testId}>
          <span className={current ? 'text-slate-800' : 'text-slate-400'}>{current ? current.name : 'Choose a client'}</span>
          <ChevronsUpDown className="w-4 h-4 text-slate-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[--radix-popover-trigger-width] min-w-[280px]" align="start">
        <Command>
          <CommandInput placeholder="Search clients…" data-testid={`${testId}-search`} />
          <CommandList className="max-h-64">
            <CommandEmpty>No client found</CommandEmpty>
            {clients.map((c) => (
              <CommandItem key={c._id} value={`${c.name} ${c.company_name || ''} ${c._id}`} onSelect={() => { onChange(c._id, c); setOpen(false); }} data-testid={`${testId}-option-${c._id}`}>
                <Check className={`w-4 h-4 mr-2 ${value === c._id ? 'opacity-100' : 'opacity-0'}`} />
                <span className="truncate">{c.name}</span>
                {c.company_name && c.company_name !== c.name && <span className="ml-2 text-xs text-slate-400 truncate">{c.company_name}</span>}
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
